// automatically generated by the FlatBuffers compiler, do not modify

/**
 * @const
 * @namespace
 */
var Ecg = Ecg || {};

/**
 * @const
 * @namespace
 */
Ecg.Viewer = Ecg.Viewer || {};

/**
 * @constructor
 */
Ecg.Viewer.EcgSignal = function() {
  /**
   * @type {flatbuffers.ByteBuffer}
   */
  this.bb = null;

  /**
   * @type {number}
   */
  this.bb_pos = 0;
};

/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {Ecg.Viewer.EcgSignal}
 */
Ecg.Viewer.EcgSignal.prototype.__init = function(i, bb) {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {Ecg.Viewer.EcgSignal=} obj
 * @returns {Ecg.Viewer.EcgSignal}
 */
Ecg.Viewer.EcgSignal.getRootAsEcgSignal = function(bb, obj) {
  return (obj || new Ecg.Viewer.EcgSignal).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns {number}
 */
Ecg.Viewer.EcgSignal.prototype.digitalMaximum = function() {
  var offset = this.bb.__offset(this.bb_pos, 4);
  return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
};

/**
 * @returns {number}
 */
Ecg.Viewer.EcgSignal.prototype.digitalMinimum = function() {
  var offset = this.bb.__offset(this.bb_pos, 6);
  return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
};

/**
 * @param {flatbuffers.Encoding=} optionalEncoding
 * @returns {string|Uint8Array|null}
 */
Ecg.Viewer.EcgSignal.prototype.physicalDimension = function(optionalEncoding) {
  var offset = this.bb.__offset(this.bb_pos, 8);
  return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @returns {number}
 */
Ecg.Viewer.EcgSignal.prototype.physicalMaximum = function() {
  var offset = this.bb.__offset(this.bb_pos, 10);
  return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
};

/**
 * @returns {number}
 */
Ecg.Viewer.EcgSignal.prototype.physicalMinimum = function() {
  var offset = this.bb.__offset(this.bb_pos, 12);
  return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
};

/**
 * @param {number} index
 * @returns {number}
 */
Ecg.Viewer.EcgSignal.prototype.data = function(index) {
  var offset = this.bb.__offset(this.bb_pos, 14);
  return offset ? this.bb.readInt16(this.bb.__vector(this.bb_pos + offset) + index * 2) : 0;
};

/**
 * @returns {number}
 */
Ecg.Viewer.EcgSignal.prototype.dataLength = function() {
  var offset = this.bb.__offset(this.bb_pos, 14);
  return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @returns {Int16Array}
 */
Ecg.Viewer.EcgSignal.prototype.dataArray = function() {
  var offset = this.bb.__offset(this.bb_pos, 14);
  return offset ? new Int16Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
};

/**
 * @param {number} index
 * @param {Ecg.Viewer.LostSamples=} obj
 * @returns {Ecg.Viewer.LostSamples}
 */
Ecg.Viewer.EcgSignal.prototype.dataLostSamples = function(index, obj) {
  var offset = this.bb.__offset(this.bb_pos, 16);
  return offset ? (obj || new Ecg.Viewer.LostSamples).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
};

/**
 * @returns {number}
 */
Ecg.Viewer.EcgSignal.prototype.dataLostSamplesLength = function() {
  var offset = this.bb.__offset(this.bb_pos, 16);
  return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @param {flatbuffers.Builder} builder
 */
Ecg.Viewer.EcgSignal.startEcgSignal = function(builder) {
  builder.startObject(7);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} digitalMaximum
 */
Ecg.Viewer.EcgSignal.addDigitalMaximum = function(builder, digitalMaximum) {
  builder.addFieldFloat32(0, digitalMaximum, 0.0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} digitalMinimum
 */
Ecg.Viewer.EcgSignal.addDigitalMinimum = function(builder, digitalMinimum) {
  builder.addFieldFloat32(1, digitalMinimum, 0.0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} physicalDimensionOffset
 */
Ecg.Viewer.EcgSignal.addPhysicalDimension = function(builder, physicalDimensionOffset) {
  builder.addFieldOffset(2, physicalDimensionOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} physicalMaximum
 */
Ecg.Viewer.EcgSignal.addPhysicalMaximum = function(builder, physicalMaximum) {
  builder.addFieldFloat32(3, physicalMaximum, 0.0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} physicalMinimum
 */
Ecg.Viewer.EcgSignal.addPhysicalMinimum = function(builder, physicalMinimum) {
  builder.addFieldFloat32(4, physicalMinimum, 0.0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} dataOffset
 */
Ecg.Viewer.EcgSignal.addData = function(builder, dataOffset) {
  builder.addFieldOffset(5, dataOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<number>} data
 * @returns {flatbuffers.Offset}
 */
Ecg.Viewer.EcgSignal.createDataVector = function(builder, data) {
  builder.startVector(2, data.length, 2);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addInt16(data[i]);
  }
  return builder.endVector();
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Ecg.Viewer.EcgSignal.startDataVector = function(builder, numElems) {
  builder.startVector(2, numElems, 2);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} dataLostSamplesOffset
 */
Ecg.Viewer.EcgSignal.addDataLostSamples = function(builder, dataLostSamplesOffset) {
  builder.addFieldOffset(6, dataLostSamplesOffset, 0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {Array.<flatbuffers.Offset>} data
 * @returns {flatbuffers.Offset}
 */
Ecg.Viewer.EcgSignal.createDataLostSamplesVector = function(builder, data) {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]);
  }
  return builder.endVector();
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} numElems
 */
Ecg.Viewer.EcgSignal.startDataLostSamplesVector = function(builder, numElems) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
Ecg.Viewer.EcgSignal.endEcgSignal = function(builder) {
  var offset = builder.endObject();
  return offset;
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} offset
 */
Ecg.Viewer.EcgSignal.finishEcgSignalBuffer = function(builder, offset) {
  builder.finish(offset);
};

/**
 * @constructor
 */
Ecg.Viewer.LostSamples = function() {
  /**
   * @type {flatbuffers.ByteBuffer}
   */
  this.bb = null;

  /**
   * @type {number}
   */
  this.bb_pos = 0;
};

/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {Ecg.Viewer.LostSamples}
 */
Ecg.Viewer.LostSamples.prototype.__init = function(i, bb) {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {Ecg.Viewer.LostSamples=} obj
 * @returns {Ecg.Viewer.LostSamples}
 */
Ecg.Viewer.LostSamples.getRootAsLostSamples = function(bb, obj) {
  return (obj || new Ecg.Viewer.LostSamples).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns {number}
 */
Ecg.Viewer.LostSamples.prototype.begin = function() {
  var offset = this.bb.__offset(this.bb_pos, 4);
  return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
};

/**
 * @returns {number}
 */
Ecg.Viewer.LostSamples.prototype.value = function() {
  var offset = this.bb.__offset(this.bb_pos, 6);
  return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
};

/**
 * @param {flatbuffers.Builder} builder
 */
Ecg.Viewer.LostSamples.startLostSamples = function(builder) {
  builder.startObject(2);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} begin
 */
Ecg.Viewer.LostSamples.addBegin = function(builder, begin) {
  builder.addFieldFloat32(0, begin, 0.0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} value
 */
Ecg.Viewer.LostSamples.addValue = function(builder, value) {
  builder.addFieldFloat32(1, value, 0.0);
};

/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
Ecg.Viewer.LostSamples.endLostSamples = function(builder) {
  var offset = builder.endObject();
  return offset;
};

// Exports for Node.js and RequireJS
this.Ecg = Ecg;
